import React from "react";

const FreeCashExpiryFields = ({ value, onChange }) => (
    <div className="grid grid-cols-3 gap-3">
        {["days", "hours", "minutes"].map((key) => (
            <div key={key}>
                <label className="text-xs font-medium text-gray-600 capitalize">{key}</label>
                <input
                    type="number"
                    min="0"
                    className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
                    value={value[key] ?? 0}
                    onChange={(e) => onChange({ ...value, [key]: e.target.value })}
                />
            </div>
        ))}
    </div>
);

export default FreeCashExpiryFields;
